module.exports = __webpack_public_path__ + "static/media/make-history.825f9d6b.svg";